module.exports = __webpack_public_path__ + "img/horizontal_6_1_9006.f8bb0ef9.png";